<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>分析任务
    </v-card-title>
    <v-card-text>
      <v-row class="mb-6 mt-2">
        <v-btn class="ml-8" color="primary" :text="queryParam.type!=0" @click="onSearch(0)">全部</v-btn>
        <v-btn class="ml-4" color="primary" :text="queryParam.type!=1" @click="onSearch(1)">未进行</v-btn>
        <v-btn color="primary" :text="queryParam.type!=2" @click="onSearch(2)">进行中</v-btn>
        <v-btn color="primary" :text="queryParam.type!=3" @click="onSearch(3)">成功</v-btn>
        <v-btn color="primary" :text="queryParam.type!=4" @click="onSearch(4)">失败</v-btn>
        <v-spacer />
        <v-text-field class="mr-4" dense label="搜索任务号或分析工具名称" single-line v-model="queryParam.searchValue" hide-details outlined rounded prepend-inner-icon="mdi-magnify" @keydown.native="onSearchValueKeydown" />
      </v-row>
      <v-row class="mb-6 mt-2" style="display:flex; align-items: center;">
        <span style="color: #FF0000">
          现已推出新版云平台，新版云平台的任务信息请前往新版查看
        </span>
        <v-btn color="primary" class="ml-2" @click="jumpNewVersion()">前往新版</v-btn>
      </v-row>
      <v-data-table :headers="headers" :items="dataList" hide-default-footer disable-sort>
        <template v-slot:item.sn="{ item }">{{dataList.indexOf(item)+1}}</template>
        <template v-slot:item.ct="{ value }">{{Utility.fmtDt(value)}}</template>
        <template v-slot:item.toolName="{ item }">
          {{item.toolId ? item.toolName : item.reportSchema}}
        </template>
        <template v-slot:item.status="{ item,value }">
          <v-tooltip v-if="value==4" top>
            <template v-slot:activator="{ on }">
              <v-chip small dark color="red" v-on="on">{{Utility.fmtCoder(value,coder_status)}}</v-chip>
            </template>
            {{item.message}}
          </v-tooltip>
          <span v-else-if="value==3">
            <v-chip small dark color="green">{{Utility.fmtCoder(value,coder_status)}}</v-chip>
          </span>
          <span v-else>
            <v-chip small color="warning">{{Utility.fmtCoder(value,coder_status)}}</v-chip>
          </span>
        </template>
        <template v-slot:item.mark="{ item }">
          <router-link v-if="item.toolId" class="text-decoration-none" :to="`/tool/task/${item.taskId}`">{{item.mark}}</router-link>
          <router-link v-else class="text-decoration-none" :to="getAnalyseUrl(item)">{{item.reportXmh}}</router-link>
        </template>
      </v-data-table>

      <v-pagination v-if="pagination.num>0" v-model="pagination.index" :length="pagination.num" :total-visible="pagination.size" @input="onPage" />
    </v-card-text>
  </v-card>

</template>
<script>
/* eslint-disable no-console */
import { queryToolTask } from '@/plugins/api';
export default {
  data () {
    return {
      headers: [
        { text: '#', value: 'sn' },
        { text: '任务号', value: 'taskId' },
        { text: '工具', value: 'toolName' },
        { text: '版本号', value: 'version' },
        { text: '任务标记', value: 'mark', },
        { text: '提交时间', value: 'ct' },
        { text: '状态', value: 'status' },
        { text: '耗时（毫秒）', value: 'msel' },
      ],
      dataList: [],
      pagination: { index: 1, size: 10, total: 0, num: 0 },
      queryParam: { type: 0, searchValue: '' },
      coder_status: [
        { code: 1, name: '未进行' },
        { code: 2, name: '进行中' },
        { code: 3, name: '成功' },
        { code: 4, name: '失败' }
      ]
    }
  },
  methods: {
    dataQuery (param) {
      queryToolTask(param).then(res => {
        this.dataList = res.data;
        this.pagination = res.pagination;
      })
    },
    onPage () {
      let param = { ...this.queryParam, pagination: { index: this.pagination.index, size: this.pagination.size } }
      this.dataQuery(param);
    },
    onSearch (type) {
      this.queryParam.type = type;
      let param = { ...this.queryParam, pagination: { index: 1, size: this.pagination.size } }
      this.dataQuery(param);
    },
    onSearchValueKeydown (e) {
      if (e.keyCode == 13) {
        let param = { ...this.queryParam, pagination: { index: 1, size: this.pagination.size } }
        this.dataQuery(param);
      }
    },

    getAnalyseUrl(item){
      let info = item.oaProjectInfo ? JSON.parse(item.oaProjectInfo) : {}
      return `/report/analyse?reportId=${item.reportId}&schema=${item.reportSchema}&xmh=${item.reportXmh}&id=${info.id}&xmfah=${info.xmfah}&htbh=${info.htbh}&csj=${info.htbh}&ypbh=${info.ypbh}`
    },
    jumpNewVersion() {
      window.open('/plus/#/project/list/tool', '_blank')
    }
  },
  created () {
    this.onSearch(0);
  },
  watch: {
    '$route' (to) {
      if (to.path == '/profile/tool/task') this.onSearch(0);
    }
  },
}
</script>